import { TENANT_COM } from 'shared/consts'
import IconNew from 'views/components/atoms/Icon/IconNew'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import Device from 'views/components/utils/Device'
import Tenant from 'views/components/utils/Tenant'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const ErxDecorator = () => {
  return (
    <Device mobile tablet>
      <Tenant tenant={TENANT_COM}>
        {() => (
          <div
            className="u-color--blue"
            data-clientside-hook="wrap-erx-announcement"
          >
            <TextWithIcon icon={<IconNew />}>
              <div className="a-h4 u-font-weight--bold u-no-margin">
                E-Rezept einlösen
              </div>
            </TextWithIcon>
          </div>
        )}
      </Tenant>
    </Device>
  )
}

export default withShopAndRuntimeConfig(ErxDecorator)
